module.exports = __webpack_public_path__ + "static/media/hexaGrey.fba7da44.svg";